module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-1-ed003722d4160dfc3ea9c793164ed201.jpg";